'use client'
import SideBarBottomSecion from './side-bar-bottom-section'
import NavLinks from '@/components/layout/nav-links'
import { ViewPort } from '@/enum/enum'
import { HeaderLayout, GeneralLayout } from '@/payload-types'

interface IProps {
  isOpen: boolean
  setIsOpen: (v: boolean) => void
  header?: HeaderLayout
  general?: GeneralLayout
}

const SideBar = ({ isOpen, setIsOpen, header, general }: IProps) => {
  const handleLinkClick = () => {
    document.body.style.overflow = ''
    setIsOpen(false)
  }
  return (
    <>
      <div className={`max-[1200px]:flex hidden max-[1200px]:flex-col max-[1200px]:h-full max-[1200px]:w-[312px] max-[1200px]:fixed max-[1200px]:z-[150] max-[1200px]:top-[55px] max-[1200px]:left-[0px] max-[1200px]:bg-black max-[1200px]:overflow-x-hidden max-[1200px]:transition-transform max-[1200px]:duration-300 max-[1200px]:ease-in-out ${isOpen ? "max-[1200px]:transform-translate-x-0" : 'max-[1200px]:translate-x-[-100%]'}`}>
        <NavLinks
          viewPort={ViewPort.MOBILE}
          onLinkClick={handleLinkClick}
          {...{ general: general }}
        />
        <SideBarBottomSecion {...{ header: header, general: general }} />
      </div>
      <div
        className={`max-[1200px]:fixed max-[1200px]:inset-0 max-[1200px]:bg-[rgba(0,0,0,.8)] max-[1200px]:z-1 max-[1200px]:overflow-hidden max-[1200px]:duration-700 max-[1200px]:ease max-[1200px]:transition-[opacity,visibility] ${isOpen ? "max-[1200px]:opacity-1 max-[1200px]:visible" : 'max-[1200px]:opacity-0 max-[1200px]:invisible'}`}
        onClick={handleLinkClick}
      ></div>
    </>
  )
}

export default SideBar
